<template>
  <div class="container-center-horizontal">
    <div class="popvalet-general-accueil screen">
      <common-sur-header />
      <common-header
        :nav-items="header.navItems"
        :cta-buttons="header.ctaButtons"
      />
      <bloc-general-accueil-title />
      <bloc-logos-clients class="logos_clients_home"/>
      <bloc-notre-organisation />
      <pop-valet-is class="general-homepage"></pop-valet-is>
      <bloc-nos-temoignages></bloc-nos-temoignages>
      <bloc-maif :txt-assurance="textAssurance" />
      <common-footer></common-footer>
    </div>
  </div>
</template>

<script>
import CommonSurHeader from "@/components/common/CommonSurHeader";
import CommonHeader from "@/components/common/CommonHeader";
import BlocGeneralAccueilTitle from "@/components/BlocGeneralAccueilTitle";
import BlocLogosClients from "./BlocLogosClients";
import BlocNotreOrganisation from "@/components/BlocNotreOrganisation";
import PopValetIs from "@/components/PopValetIs";
import BlocNosTemoignages from "@/components/BlocNosTemoignages";
import BlocMaif from "./BlocMaif";
import CommonFooter from "@/components/common/CommonFooter";

export default {
  name: "PopvaletGeneralAccueil",
  components: {
    CommonHeader,
    CommonSurHeader,
    BlocGeneralAccueilTitle,
    BlocLogosClients,
    BlocNotreOrganisation,
    PopValetIs,
    BlocNosTemoignages,
    BlocMaif,
    CommonFooter
  },
  props: [
    'header',
    "textAssurance"
  ],
};
</script>

<style>
@media screen and (max-width: 991px) {
  .popvalet-general-accueil {
    width: 1440px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1440px) {
  .popvalet-general-accueil {
    width: 1440px;
  }
}

@media screen and (min-width: 1441px) {
  .popvalet-general-accueil {
    width: 100%;
    align-items: unset;
  }
}

.popvalet-general-accueil {
  background-color: var(--blanc);
  border: 1px none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
</style>
